<template>
  <div class="e-list" :class="{ 'e-list__loading': !error && loading }">
    <slot v-if="error" name="error">
      <e-hint variant="danger">{{ error }}</e-hint>
    </slot>
    <slot v-else-if="loading" name="loading">
      <e-circular-loading :value="loading" />
    </slot>
    <slot v-else-if="value.length === 0" name="empty">
      <e-empty :title="emptyText" />
    </slot>
    <v-list v-else class="e-list__list">
      <slot name="list:before" />
      <v-list-item-group color="dark">
        <slot :items="items">
          <EListItem
            v-for="(item, index) in items"
            :key="index"
            v-bind="listItemOptions(item, index)"
            :item="item"
            :inactive="inactive"
            :ripple="inactive ? false : undefined"
            @click="$emit('click', { item, index, event: $event })"
          />
        </slot>
      </v-list-item-group>
      <div v-if="infinity" :key="infinityScrollKey" v-intersect="infinityScrollShowNext" />
      <slot name="list:after" />
    </v-list>
  </div>
</template>

<script>
import { VListItemGroup, VList } from 'vuetify/lib'
import EListItem from './EListItem.vue'
import { EHint, ECircularLoading, EEmpty } from '../index'
import { infinityScrollMixin } from '../../mixins'

export default {
  name: 'EList',
  components: {
    VListItemGroup,
    VList,
    EListItem,
    EHint,
    ECircularLoading,
    EEmpty,
  },

  mixins: [infinityScrollMixin],

  props: {
    value: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: 'Empty',
    },
    error: {
      type: String,
      default: '',
    },
    inactive: {
      type: Boolean,
      default: false,
    },
    listItemOptions: {
      type: Function,
      default: () => {},
    },
    infinity: {
      type: [Boolean, Number],
      default: false,
    },
  },

  computed: {
    infinityItemsCountPerList() {
      return !this.infinity || typeof this.infinity === 'boolean' || this.infinity < 0
        ? this.INFINITY_ITEMS_COUNT_PER_LIST
        : this.infinity
    },

    infinityItems() {
      return this.value
    },

    items() {
      return this.infinity ? this.infinityItemsPerList : this.infinityItems
    },
  },
}
</script>
